/**
 * @fileoverview AR-805 — loading placeholders for the integrations page.
 *
 * They mirror the REAL geometry of each block (same heights, gaps and
 * alignment) so the content swaps in without the layout jumping: the card
 * header is always rendered for real — only the data area is a placeholder.
 */

import { Group, Skeleton, Stack, Table } from '@mantine/core'

/** Mantine v6 metrics of the elements being replaced. */
const TEXT_SM_HEIGHT = 22 // Text size="sm" line box
const TEXT_XS_HEIGHT = 19 // Text size="xs" line box
const BUTTON_HEIGHT = 36 // Button size="md" (default)
const BUTTON_WIDTH = 116 // "Disconnect" / "Connect Google Workspace" footprint
const TABLE_ROWS = 3

/**
 * Connected/disconnected body: two info lines on the left, action button on
 * the right — same `position="apart"` + `align="flex-end"` as the real Group.
 */
export function ConnectionBodySkeleton() {
  return (
    <Group position='apart' align='flex-end'>
      <Stack spacing={2}>
        <Skeleton height={TEXT_SM_HEIGHT} width={260} radius='sm' />
        <Skeleton height={TEXT_SM_HEIGHT} width={200} radius='sm' />
      </Stack>
      <Skeleton height={BUTTON_HEIGHT} width={BUTTON_WIDTH} radius='xl' />
    </Group>
  )
}

/**
 * Courses table placeholder: real header row + rows at the exact height of a
 * populated row, so switching to data does not resize the card.
 */
export function CoursesTableSkeleton() {
  return (
    <Table verticalSpacing='sm'>
      <tbody>
        {Array.from({ length: TABLE_ROWS }, (_, row) => (
          <tr key={row}>
            <td>
              <Skeleton height={TEXT_SM_HEIGHT} width='70%' radius='sm' />
            </td>
            <td>
              <Skeleton height={TEXT_XS_HEIGHT} width={64} radius='sm' />
            </td>
            <td>
              <Skeleton height={TEXT_XS_HEIGHT} width={96} radius='sm' />
            </td>
            <td>
              <Skeleton height={TEXT_XS_HEIGHT} width={140} radius='sm' />
            </td>
            <td>
              <Skeleton height={TEXT_XS_HEIGHT} width={72} radius='xl' />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
